import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const styles = {
  customProgressAnimation: {
    animation:
      'MuiCircularProgress-keyframes-circular-rotate 0.7s linear infinite'
  },
  breakLine: {
    whiteSpace: 'pre-line',
    fontSize: 14
  },
  title: {
    textAlign: 'center'
  },
  footer: {
    padding: 20,
    display: 'block'
  },
  modalMobile: {
    maxWidth: 375,
    margin: 'auto'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openProgress,
    progressOkAction = null,
    loading,
    resultMessage = null,
    title = null,
    btnText = null,
    btnType = 'button',
    disableScrollLock
  }) => {
    return (
      <Dialog
        open={openProgress}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        className={classes.modalMobile}
        disableScrollLock={disableScrollLock}
      >
        {!loading && title && (
          <DialogTitle id="alert-dialog-title" className={classes.title}>
            {title}
          </DialogTitle>
        )}
        <DialogContent>
          {!loading ? (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.breakLine}
            >
              {resultMessage}
            </DialogContentText>
          ) : (
            <Fade in={loading} unmountOnExit>
              <CircularProgress
                disableShrink
                className={classes.customProgressAnimation}
              />
            </Fade>
          )}
        </DialogContent>
        {!loading && resultMessage && (
          <DialogActions className={classes.footer}>
            {btnType === 'text' ? (
              <Button type="text" color="primary" onClick={progressOkAction}>
                {!btnText ? 'OK' : btnText}
              </Button>
            ) : (
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={progressOkAction}
              >
                {!btnText ? 'OK' : btnText}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
